import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Card } from 'tea-component';
import { useSelector , connect, useLocation } from "umi";
import FilterBase from '@/pages/dashboard/components/NewFilter/FilterBase';
import { isEmpty } from 'lodash-es';
import { parseUrlInfo } from '@/pages/dashboard/utils/utils';
import { findPageSelector, getFilterCacheValue, setFilterCacheValue, getDefaultValueFromCache, formatCacheValue, getRangePickerDefaultValue, getDefaultValueFromUrl, getDefaultValueFromSaved, getDefaultValue, getUrlParams, getFilterSaveDateVal, saveIsEqualConfirm, mapCascadeFieldsToInputList, isNewCascadeFilter, getFilterOptionSource } from './util';
import { SELECTOR_KEY_MAP } from './_config';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import '@/pages/dashboard/components/Filter/index.scss';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { CountryItemType } from '@/pages/dashboard/types/dashboard';
import { DATE_FILTER_ARR, RANGE_DATE, RANGE_DAY_MONTH, REGION, BUILTIN_CASCADE_RENDER_KEYS } from '@/pages/dashboard/components/NewFilter/FilterBase/_config';
import { FilterTitle } from './FilterTitle';
import useSticky from './useSticky';
import { FILTER_CACHE_VALUE_KEY, storage } from '@/utils/utils';
import FilterSave from './FilterSave';
import useSaveInput from './FilterSave/useSaveInput';
import { DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY, DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY, DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY } from '../../_config/constant';
import { filterSaveDurationValue } from './FilterBase/filterSaveDurationValue';
import { START_OF_DATE } from '../../utils/_config/constant';
import { filterDlActiveReportSelector } from '../../_config/filterListMap';
import './index.scss';
interface LockFilterInfoType {
  value: any;
}

// 筛选器组件每进入一个页面，重新初始化一次，避免冲突
const Filter = (props: any) => {
  const {
    loading,              // 筛选器外部loading,筛选器会在外部loading结束后执行初始化 init
    isHaveFilterCache = true,      // 是否开启筛选器会话继承
    gameCode,
    onInit,
    path = '',            // 是否显示筛选器， 不显示的时候展示loading状态
    latestDateLoading,
    selectorLoading,      // getSelector 的 loading 状态（从 Redux 获取）
    gameConfig,
    selector,
    dispatch,
    outSelector,
    value,
    inputList,
    latestDateType,       // undefined, '', string,空字符串的时候代表dau
    useOutInput = false,  // 使用外部的inputList，不使用从后端获取的筛选器配置
    onConfirm: propsOnConfirm,
    onReset: propsOnReset,
    onChange: propsOnChange,
    filterSaveOnChange,
    latestDate,
    outLatestDate,
    openSticky = false,
    segmentFloatStickySyncId,
    isHaveFilterSave = true, // 是否有筛选器保存功能（ua和竞品没有）
    pageDefaultSelector,  // 前端页面级筛选器默认处理
    useFrontFilterConfig = false, // 特殊逻辑，例如事件对比，当后端配置了默认值，但是没有配置页面配置则直接使用前端配置（前端默认配置>后端默认配置）
    outSelectorSchemeList, // 外部传入的筛选器方案
    getOutSelectorSchemeList, // 外部请求筛选器方案
    dataFrame,
    filterDurationData,
    children, // 子组件
    extraRenderContent,
    tailSlot,
    stickyTrailingSlot,
    className,
    ...restProps
  } = props;

  // 是否页面定制化筛选器方案
  const isOutScheme = !!outSelectorSchemeList;

  // 接收外部页面定制化筛选器方案
  const selectorSchemeList = useSelector((state: any) => {
    const { dashboardSetting: { selectorSchemeList } } = state;
    return outSelectorSchemeList ? outSelectorSchemeList : selectorSchemeList;
  });

  // 如果是外部数据源，则取数据源中的最新时间
  const location = useLocation();
  const [lockFilterInfo, setLockFilterInfo] = useState<LockFilterInfoType>({
    value: null // null 代表未初始化
  });
  const [showBubble, setShowBubble] = useState(false);
  const filterRef = useRef<HTMLDivElement>(null);
  const defaultValueRef = useRef<any>({});
  const filterChangeRef = useRef(false);
  const { locale, getLocalText } = useLocal('filter');
  const isInitRef = useRef<boolean | null>(null);  // 是否调用过初始化函数，修改过value的值。用来处理筛选器初始化的时候闪动的问题
  // const { filterSaveVal, isUseFilterSaveVal } = useFilterSaveStorageMessage(gameCode)
  const { userId } = storage.getItem(DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY) || {};
  const filterStorageSave = storage.getItem(isOutScheme ? DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY : DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY);
  const filterSaveVal:any = filterStorageSave ? getFilterSaveDateVal(filterStorageSave) : {};
  const { userId: filterSaveUseId, gameCode: filterSaveGame } = filterSaveVal || {};
  const isUseFilterSaveVal = filterSaveUseId === userId && filterSaveGame === gameCode && filterSaveVal;
  useEffect(() => {
    if (gameCode) {
      // 初始化锁定值状态
      if (lockFilterInfo.value === null) {
        const lockValue = getFilterCacheValue(gameCode);
        setLockFilterInfo({
          value: lockValue.value || {}
        });
      }
    }
  }, [gameCode]);

  // 筛选器保存页面展示的默认方案，
  const defaultSelectedItem = useMemo(() => selectorSchemeList?.filter((item: any) => item.filter_cond.is_default)?.[0] || [], [selectorSchemeList]);

  // 获取latestDate逻辑，非关键逻辑
  useEffect(() => {
    if (gameCode && !latestDateLoading && !outLatestDate) {
      // todo 判断是否有latestDateType,目前是否一个页面只有一个lateast类型？
      // 有时在第一次 getLatestDate接口没有请求完成的情况下, 代码又走到这里, 导致了接口的二次请求
      // 所以添加 latestDateLoading 判断
      const type = latestDateType || 'dau';
      // 判断gamecode是否相同,是否有这个类型的数据
      if (latestDate?.gameCode !== gameCode || !latestDate?.[type]) {
        dispatch({
          type: "dashboardSetting/getLatestDate",
          payload: {
            gameCode,
            type
          }
        });
      }
    }
  }, [gameCode, latestDate, latestDateLoading, outLatestDate]);

  // 非关键逻辑
  const memoLatestDate: any = useMemo(() => {
    if (outLatestDate) {
      return outLatestDate;
    }
    if (latestDateType !== undefined) {
      const type = latestDateType || 'dau';
      return latestDate?.[type];
    }
    return undefined;
  }, [latestDate, latestDateType, outLatestDate]);

  useEffect(() => {
    const durationData = filterSaveDurationValue(START_OF_DATE, memoLatestDate, gameConfig?.season_info, dispatch);
    dispatch({
      type: "dashboardSetting/setFilterSaveDurationDate",
      payload: {
        data: durationData
      }
    });
  }, [gameCode, gameConfig, memoLatestDate]);

  // loading 态
  const isLoading: boolean = useMemo(() => {
    // 校验是否获取到config和selector数据
    // defaultSelectedItem 为筛选器默认方案，得获取到默认方案后再进行请求
    const { urlId: urlGameCode } = parseUrlInfo(location.pathname);
    // 如果config接口返回值为空，或者请求失败，或者当前游戏url中gamecode与config接口返回的gamecode不一致，则筛选器处理为loading状态
    const checkConfig = gameCode && gameConfig && gameConfig?.game_code === gameCode && gameConfig?.game_code === urlGameCode;
    const checkSelector = outSelector || (gameCode && selector?.gameCode === gameCode);
    // const checkDefaultSelectedItem = !defaultSelectedItem || 
    // 如果 selector 正在加载中，或者外部传入的 loading 为 true，则保持 loading 状态
    // 这样可以确保在 new_selector 请求完成前，不会使用错误的 selector 进行级联筛选器继承
    return loading || selectorLoading || !checkConfig || !checkSelector || lockFilterInfo.value === null || (!defaultSelectedItem) || (!filterDurationData);
  }, [loading, selectorLoading, gameConfig, selector, lockFilterInfo, gameCode, defaultSelectedItem, location.pathname, outSelector]);

  // 获取selector
  const selectorList = useMemo(() => {
    if (isLoading) return [];
    const { default_selector: defaultSelector = [], page_selector: pageSelector = [] } = gameConfig || {};
    // 优先取筛选器的path
    let realPath = path;
    if (!realPath) {
      const pathInfo = parseUrlInfo(location.pathname);
      realPath = pathInfo.realPath;
    }
    const result = findPageSelector(realPath, pageSelector, defaultSelector, dataFrame, pageDefaultSelector,useFrontFilterConfig);

    return result;
  }, [isLoading, location.pathname, path, dataFrame]);

  // 根据筛选器配置，设置真实的inputlist
  const realInputList = useMemo(() => {
    if (isLoading) {
      return [];
    }
    // 外部的inputlist
    let realInputList = [...inputList];
    const selectorListKeyArr = selectorList?.map(item => item?.key);

    // 组合页面配置的inputlist
    if (!useOutInput) {
      selectorList.forEach(((item) => {
        if (!realInputList.find((inItem: any) => (inItem.type || inItem.key) === item.key)) {
          realInputList.push(item);
        }
      }));
    }

    // 设置input options值
    realInputList = realInputList.map((item: any) => {
      // 获取筛选器类型，优先取type，没type取key值
      const key: string = item.type || item.key;

      if (item?.isUseConfig) {
        const configItem = selectorList?.filter((cfg: any) => cfg.key === key)?.[0];
        const isHaveConfig = selectorListKeyArr?.includes(key);

        if (!isHaveConfig && !item?.allowMissingBackendKey) {
          return null;
        }
        if (isHaveConfig) {
          if (key === 'region') {
            const defaultVal = {
              region_type: 'market',
              markets: configItem?.default,
            };
            item = {
              ...item,
              visible: configItem?.visible,
              default: defaultVal,
              name_en: configItem?.name_en,
              name_cn: configItem?.name_cn,
            };
          } else {
            item = {
              ...item,
              visible: configItem?.visible,
              default: configItem?.default,
              name_en: configItem?.name_en,
              name_cn: configItem?.name_cn,
            };
          }
        }
      }

      // @ts-ignore
      // selector数据源中对应的键值key
      // optionDataKey 是上层强制传入取options的key，背景：自定义筛选器自定义了重复的key（和之前已有的筛选器key重复），取数据导致取到了SELECTOR_KEY_MAP映射的list
      const mapKey = item?.optionDataKey || SELECTOR_KEY_MAP[key] || key;
      // todo 各个input的特殊处理，应该封装为各自独立的方法，拆分到主逻辑之外，降低主逻辑的复杂度
      // 设置初始默认值，region需特殊处理， 如果是内部配置的region，default: ['255']转换成  default: {markets: ['255'], region_type: 'market'}，外部的保持原状
      let defaultVal: any = item.default;
      if (typeof defaultVal === 'function') {
        defaultVal = defaultVal(gameConfig.time_zone || '+0');
      }
      if (key === REGION && !inputList.find((inItem: any) => ((inItem.type || inItem.key) === key))) {
        defaultVal = {
          region_type: 'market',
          markets: item.default,
          regions: []
        };
      }
      
      // 新的级联筛选器默认值处理（参照 region 的处理方式）
      // 如果是内部配置的新级联筛选器，将 default: ['255'] 转换成对象格式
      // 注意：BUILTIN_CASCADE_RENDER_KEYS 中的筛选器在 FilterList.tsx 的内置 render 中自己处理 cascade 格式转换，不在此处转换
      if (isNewCascadeFilter(item, key) && !BUILTIN_CASCADE_RENDER_KEYS.includes(key)) {
        const parentKey = item?.parentKey || 'parent';
        const childKey = item?.childKey || key;
        
        // 如果 defaultVal 是数组（如 ['255']），转换为对象格式
        if (Array.isArray(defaultVal)) {
          defaultVal = {
            [parentKey]: [],
            [childKey]: defaultVal,
            type: childKey,
          };
        } else if (!defaultVal) {
          // 如果没有默认值，设置一个空的结构（参照 region 的处理，确保重置后不会为空）
          defaultVal = {
            [parentKey]: [],
            [childKey]: [],
            type: childKey,
          };
        }
      }
      
      defaultValueRef.current[item.key] = defaultVal;
      if (key === RANGE_DATE && !isEmpty(lockFilterInfo.value)) { // 锁定状态下，修改RangePicker 的默认值（componentDefaultValue）
        const { componentDefault } = item;
        item.componentDefault = getRangePickerDefaultValue(gameCode, componentDefault);
      }
      // 如果有传入外部selector，则使用外部的selector；bundle 等特殊逻辑在 getFilterOptionSource 中统一处理
      const curSelector = outSelector || selector;
      const optionSource = getFilterOptionSource(curSelector, key, mapKey);
      if (optionSource) {
        // region特殊处理 设置popularList
        if (key === REGION && !item?.popularList && selector?.key_country_list) {
          item.popularList = (selector.key_country_list || []).map((country: CountryItemType) => country.country_code);
        }
        return {
          ...item,
          default: defaultVal,
          // @ts-ignore
          options: [...optionSource]
        };
      }
      return {
        ...item,
        default: defaultVal
      };
    });

    // 对级联筛选器进行字段映射
    const filteredList = realInputList?.filter(item => item) || [];
    const mappedInputList = mapCascadeFieldsToInputList(filteredList, locale);

    return mappedInputList;
  }, [isLoading, inputList, useOutInput, selector, selectorList, outSelector, value, locale]);

  const {
    formValue,
    selectedValue,
    setFormValue,
    filterSchemeChange,
    setSelectedValue,
    filterModalInfo,
    setFilterModalInfo,
  } = useSaveInput({ value, defaultValue: defaultValueRef.current, realInputList, selector: isOutScheme ? outSelector : selector, gameCode, defaultSelectedItem, isOutScheme, filterSaveOnChange });

  useMemo(() => {
    if (isInitRef.current === false) {
      isInitRef.current = true;
    }
  }, [value]);

  // 筛选器初始化，触发init
  useEffect(() => {
    if (!isLoading && onInit) {
      isInitRef.current = false;
      // 获取url中state的值，默认state中filterParams是空的
      const filterState: any = location?.state || { filterParams: '' };
      const filterUrlParams: any = getUrlParams(location?.query, realInputList); // todo query ts报错
      const urlFilterParams = typeof filterState === 'string' ? JSON.parse(filterState)?.filterParams : filterState?.filterParams;
      let value: any = {};
      const urlIsNotEmpty = !isEmpty(filterUrlParams?.filterValue);
      // 优先级： url>state>筛选器方案继承>默认
      if (urlIsNotEmpty) {
        value = getDefaultValueFromUrl(realInputList, filterUrlParams, defaultValueRef.current);
      } else if (urlFilterParams) {// 下钻继承
        value = getDefaultValueFromUrl(realInputList, urlFilterParams, defaultValueRef.current);
      } else if (isHaveFilterSave && (isUseFilterSaveVal || !isEmpty(defaultSelectedItem)) && !isOutScheme) {// 筛选器方案继承
        value = getDefaultValueFromSaved(realInputList, (filterSaveVal?.filter_cond || defaultSelectedItem?.filter_cond), defaultValueRef.current, selector, filterDurationData);
      } else if (isHaveFilterSave && isOutScheme && !isEmpty(defaultSelectedItem)) {// 定制化筛选器默认方案应用
        value = getDefaultValueFromSaved(realInputList, defaultSelectedItem?.filter_cond, defaultValueRef.current, outSelector, filterDurationData);
      } else if (!isEmpty(lockFilterInfo.value) && isHaveFilterCache) {
        value = getDefaultValueFromCache(realInputList, lockFilterInfo.value, defaultValueRef.current, outSelector || selector);
      } else {
        // 切换页面设置值。(UA、Competitor不使用筛选器方案)
        // （!isHaveFilterSave ? {} : defaultSelectedItem） 应该只是需要 {}才对
        value = getDefaultValue(realInputList, defaultValueRef.current, !isHaveFilterSave ? {} : defaultSelectedItem);
      }
      filterChangeRef.current = false;
      // 如果触发继承逻辑，则代表筛选器动过，设置diff值
      const isHaveFilterValue = (urlIsNotEmpty || urlFilterParams || (isHaveFilterSave && isUseFilterSaveVal && !isOutScheme) ||
      (isHaveFilterSave && isOutScheme) || !isEmpty(lockFilterInfo.value) || (isHaveFilterSave && !isOutScheme && !isEmpty(defaultSelectedItem)));
      onInit({ ...value }, realInputList, isHaveFilterValue);
    }
  }, [isLoading]);
  // confirm 事件
  const onConfirm = useCallback((value: any): void => {
    filterChangeRef.current = false;
    // if (lockFilterInfo.isLock) {
    //   setLockValue(value);
    // }
    isHaveFilterCache && saveCache(value);
    propsOnConfirm?.(value, realInputList);
    if (isHaveFilterSave) {
      const filterSaveValue = getDefaultValueFromSaved(realInputList, selectedValue?.filter_cond, defaultValueRef.current, isOutScheme ? outSelector : selector, filterDurationData);
      const filterSaveVal = getFilterSaveDateVal(selectedValue);
      const {ext_filter,...filters} = filterSaveVal?.filter_cond || {};

      // 不影响之前逻辑，暂时性特殊处理竞品页面的情况
      // TODO 竞品页面新增最早日期，rangeDayMonth里是否需加上类型的判断，需要减少特殊处理提高可维护性
      const isRemoveStorageFlag = (!restProps.alignedType && restProps.alignedType !== '') ? 
        saveIsEqualConfirm(filterSaveValue, value) : 
        saveIsEqualConfirm(
          { ...filterSaveValue, ...({
            alignedType: ext_filter.alignedType ? 
              ext_filter.alignedType : 
              // eslint-disable-next-line no-prototype-builtins
              ext_filter.hasOwnProperty(RANGE_DAY_MONTH) ? 
                'launch_time' : ''}) }, 
          { ...value, ...({alignedType: restProps.alignedType}) });
      
      if (isRemoveStorageFlag) {
        setSelectedValue({});
        storage.removeItem(isOutScheme ? DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY : DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY);
      } else {
        const { userId } = storage.getItem(DB_DASHBOARD_LOCAL_CURRENT_GAME_KEY) || {};
        const filterSaveValues = {...(filters || {}),...(ext_filter|| {})};
        // 兜底不为空才存 （例如：默认方案的时候，点reset再点确认会存储一个空）
        if(!isEmpty(filterSaveValues)) {
          storage.setItem(
            isOutScheme ? DB_DASHBOARD_LOCAL_FILTER_SAVE_OUT_SCHEME_KEY : DB_DASHBOARD_LOCAL_FILTER_SAVE_SCHEME_KEY, 
            { ...filterSaveVal, userId, gameCode });
        }
      }
    }
  }, [propsOnConfirm, realInputList, lockFilterInfo, selectedValue]);


  // reset 事件
  const onReset = useCallback((value: any): void => {
    filterChangeRef.current = false;
    propsOnReset?.(value, realInputList);
    setFormValue(defaultValueRef?.current);

    storage.removeSessionStorageItem(FILTER_CACHE_VALUE_KEY);
    dispatch({
      type: 'dashboardSetting/setFilterSaveDuration',
      payload: {
        data: '',
      },
    });
    props?.dispatch({
      type: 'rangePikerLeft/setRangePickerLeftData',
      payload: {
        data: []
      },
    });
  }, [propsOnReset, realInputList, lockFilterInfo]);
  // onChange 事件
  const onChange = (key: any, val: any): void => {
    if (JSON.stringify(val) !== JSON.stringify(value?.[key])) {
      filterChangeRef.current = true;
    }
    propsOnChange?.(key, val, formValue);

    if (isHaveFilterSave) {
      // 筛选器保存逻辑
      // todo 这里key是业务逻辑里可以随意命名的，不是固定不变的，以key为判断的时候要注意
      const isDate = DATE_FILTER_ARR.includes(key);
      const saveFilterInit = { ...formValue, [key]: val };
      let saveFilterValue = getDefaultValueFromSaved(realInputList, saveFilterInit, defaultValueRef.current, isOutScheme ? outSelector : selector, filterDurationData, formValue);
      if (isDate) {
        saveFilterValue = { ...saveFilterValue, [key]: val };
      }
      setFormValue(saveFilterValue);
    }
  };

  // // 锁定的时候保存数据
  // const setLockValue = (value: any): void => {
  //   const formatValue = formatCacheValue(realInputList, value);
  //   setFilterCacheValue(formatValue, gameCode, true);
  // }

  const saveCache = (formVal: any) => {
    const formatValue = formatCacheValue(realInputList, formVal) || {};
    setFilterCacheValue(formatValue, gameCode);
    setLockFilterInfo({
      value: formatValue
    });
  };

  const {
    isSticky,
    isVisiable,
    openTransition,
    isExpand,
    handleOpenExpand,
    handleCloseExpand,
    // headerFilterHeight,
    pageFilterHeight
  } = useSticky({
    isLoading,
    isHaveFilterSave,
    inputList: realInputList,
    openSticky,
    filterChange: filterChangeRef.current,
    filterRef,
    segmentFloatStickySyncId,
  });

  const handleCloseFilter = () => {
    if (!openSticky) {
      return;
    }
    // 等待筛选框的onChange
    setTimeout(() => {
      if (filterChangeRef.current) {
        setShowBubble(true);
        filterChangeRef.current = false;
        setTimeout(() => {
          setShowBubble(false);
        }, 3000);
      } else {
        setShowBubble(false);
        handleCloseExpand();
      }
    }, 30);
  };

  return <>
    <div ref={filterRef} className={`dbd-filter-container ${className}`}>
      {/* 占位dom */}
      {isSticky && <div style={{ height: `${pageFilterHeight  }px` }}></div>}
      {/* 背景浮层 */}
      {isSticky && isExpand && <div className='dbd-filter-cover' onClick={handleCloseFilter}></div>}
      <Card
        className={isSticky ? `dbd-filter-sticky ${isVisiable ? 'filter-visiable' : ''} ${isExpand ? 'filter-expand' : ''} ${openTransition ? 'open-transition' : ''}` : ''}
        onClick={handleOpenExpand}
      // style={{height: !isSticky ? 'auto' : isExpand ? `${headerFilterHeight}px` : '45px'}}
      >
        <Card.Body>
          <Abnormal
            isLoading={false}
            componentLoading={isLoading || !isInitRef.current}
            style={{ height: 92 }}
            advanceRender={false}
            component={(
              <>
                {openSticky && <FilterTitle
                  realInputList={realInputList}
                  gameCode={gameCode}
                  formValue={formValue}
                  outSelector={outSelector}
                  stickyTrailingSlot={stickyTrailingSlot}
                />}
                <FilterBase
                  className="dbd-filter-content-wrap"
                  {...restProps}
                  gameCode={gameCode}
                  filterSaveConfig={{
                    isHaveFilterSave,
                    isOutScheme,
                    selectorSchemeList,
                    setSelectedValue,
                    setFilterModalInfo,
                  }
                  }
                  value={formValue}
                  defaultValue={defaultValueRef.current}
                  inputList={realInputList}
                  onConfirm={onConfirm}
                  onReset={onReset}
                  onChange={onChange}
                  showBubble={showBubble}
                  setShowBubble={setShowBubble}
                  latestDate={memoLatestDate}
                  extraSlot={
                    <>
                      {
                        extraRenderContent && React.Children.map(extraRenderContent, child => React.cloneElement(child, {}))
                      }
                    </>
                  }
                  inputSlot={
                    <>
                      {isHaveFilterSave && <FilterSave
                        path={path}
                        selector={outSelector ? outSelector : selector}
                        isOutScheme={isOutScheme}
                        selectorSchemeList={selectorSchemeList}
                        getOutSelectorSchemeList={getOutSelectorSchemeList}
                        filterModalInfo={filterModalInfo}
                        setFilterModalInfo={setFilterModalInfo}
                        selectedValue={selectedValue}
                        setSelectedValue={setSelectedValue}
                        realInputList={realInputList}
                        filterSchemeChange={filterSchemeChange}
                        formValue={formValue} 
                        {...restProps}
                      />}
                    </>
                  }
                  tailSlot={
                    <>
                      {tailSlot}
                    </>
                  }
                />
                {openSticky && <div
                  className="mod-filter-button-close"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleCloseFilter();
                    return false;
                  }}
                >
                  {getLocalText(`close_message`)}
                  <div className='mod-filter-button-close-down' />
                </div>}
              </>
            )}
          />
        </Card.Body>
      </Card>
    </div>
    {
      children && React.Children.map(children, child => React.cloneElement(child, {}))
    }
  </>;
};

export default connect((state: any, ownProps: any) => {
  const { loading, dashboard, dashboardSetting: { gameConfig, latestDate, selector, filterDurationData } } = state;
  const gameCode = dashboard?.currentGame?.game_code || '';
  const platformOptionFilter = ownProps.config?.platformOptionFilter;
  return {
    gameConfig,
    latestDate,
    selector: filterDlActiveReportSelector(selector, gameCode, ownProps.path, platformOptionFilter),
    outSelector: filterDlActiveReportSelector(ownProps.outSelector, gameCode, ownProps.path, platformOptionFilter),
    // selectorSchemeList,
    gameCode,
    dataFrame: dashboard?.currentGame?.data_frame || 'mobile',
    filterDurationData,
    latestDateLoading: loading.effects['dashboardSetting/getLatestDate'],
    selectorLoading: loading.effects['dashboardSetting/getSelector'],
  };
})(Filter);
